import React, { useEffect, useRef } from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as exclamatory } from '@/assets/icons/exclamatory.svg';
import styles from './QuantityPrompt.module.scss';

export interface QuantityPromptAction {
  id: string;
  label: string;
  onClick: () => void;
  tone: 'primary' | 'secondary' | 'quiet' | 'danger';
  description?: string;
  disabled?: boolean;
}

interface QuantityPromptProps {
  titleId: string;
  title: string;
  message: string;
  actions: QuantityPromptAction[];
  children?: React.ReactNode;
}

export const QuantityPrompt: React.FC<QuantityPromptProps> = ({
  titleId,
  title,
  message,
  actions,
  children,
}) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    dialogRef.current?.focus();
  }, [titleId]);
  return (
    <div className={styles.overlay}>
      <div
        ref={dialogRef}
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={`${titleId}-message`}
        tabIndex={-1}
      >
        <SvgIcon
          component={exclamatory}
          viewBox="0 0 40 40"
          className={styles.icon}
          aria-hidden="true"
        />
        <h2 id={titleId} className={styles.title}>
          {title}
        </h2>
        <p id={`${titleId}-message`} className={styles.message}>
          {message}
        </p>
        {children}
        <div className={styles.actions}>
          {actions.map((action) => (
            <div key={action.id} className={styles.actionBlock}>
              <button
                type="button"
                className={`${styles.action} ${styles[action.tone]}`}
                onClick={action.onClick}
                disabled={action.disabled}
                aria-describedby={action.description ? `${action.id}-description` : undefined}
              >
                {action.label}
              </button>
              {action.description && (
                <p id={`${action.id}-description`} className={styles.actionDescription}>
                  {action.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
